import { trackEvent } from '@patrianna/analytics'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import type { ReactNode } from 'react'

import ROUTES from 'config/routes.json'
import authPages from 'prismic-translates/auth-pages.json'

import AuthWaysTitle from './AuthWaysTitle'
import classes from './styles.module.scss'

const t = getTranslationFromJson([authPages])

type Props = {
  children: ReactNode
  loginLinkClass?: string
}

export default function AuthContent(props: Props) {
  const searchParams = useSearchParams()
  const query = searchParams.toString()
  const authType = searchParams.get('type')

  const onClick = () => {
    trackEvent('register_page_login_link')
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.captions}>
          <AuthWaysTitle type={authType} />
        </div>

        <img
          className={classes.banner}
          src={`${process.env.IMG_ORIGIN}/auth-banners/${process.env.BRAND_NAME}.png`}
          alt='sign in'
        />

        {props.children}
      </div>
      <h6 className={cx(classes.accountLink, props.loginLinkClass)}>
        {t('already_got_account')}?{' '}
        <Link
          href={{
            pathname: ROUTES.LOGIN,
            query,
          }}
          prefetch={false}
          className={classes.link}
          onClick={onClick}
        >
          {t('log_in')}
        </Link>
      </h6>
    </>
  )
}
